import { Component, Input } from '@angular/core';

@Component({
	selector: 'ui-icon-button',
	templateUrl: './icon-button.component.html',
	styleUrls: ['./icon-button.component.less'],
})
export class UIIconButtonComponent {
	@Input() icon: string;
	@Input() type: string;
	@Input() use_branding: boolean = false;
	@Input() on_dark: boolean = false;
	@Input() is_large: boolean = false;
}
